/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { View } from "react-native";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import {
  upduoPrimaryBlack,
  upduoPrimaryDark,
  upduoMediumGray,
} from "config/UpduoColors";
import { SummitType } from "graphql/internal/generated";
import { Text } from "UpduoLibrary";
import { download, formattedSummitDateRangeString } from "config/Utilities";
import { createEvent } from "ics";
import exportCalendarSVG from "assets/export-calendar.svg";

export default function SummitDescription({
  summit,
  startDate,
  endDate,
}: {
  summit: SummitType;
  startDate: Date;
  endDate: Date;
}) {
  const selfObject = useSelector((state: RootState) => state.selfObject);

  const headerStyle = {
    color: upduoPrimaryDark,
    paddingBottom: 20,
    fontSize: 16,
  };

  const _handleExportCalendar = () => {
    if (startDate && endDate) {
      createEvent(
        {
          title: `Upduo Event: ${summit.name}`,
          description: summit.description,
          start: [
            startDate.getUTCFullYear(),
            startDate.getUTCMonth() + 1,
            startDate.getUTCDate(),
            startDate.getUTCHours(),
            startDate.getUTCMinutes(),
          ],
          startInputType: "utc",
          endInputType: "utc",
          end: [
            endDate.getUTCFullYear(),
            endDate.getUTCMonth() + 1,
            endDate.getUTCDate(),
            endDate.getUTCHours(),
            endDate.getUTCMinutes(),
          ],
          url: window.location.href,
          organizer: {
            name: selfObject.organizationName,
          },
        },
        (error, value) => {
          if (error) {
            console.log(error);
          }

          download(
            value,
            `Upduo Event: ${summit.name}`,
            "text/calendar;charset=utf-8"
          );
        }
      );
    }
  };

  return (
    <View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
        }}
      >
        <Text style={headerStyle}>{"Event Duration"}</Text>
        <span onClick={_handleExportCalendar}>
          <img
            src={exportCalendarSVG}
            style={{ marginLeft: 15, marginTop: 1, cursor: "pointer" }}
            alt={"export calendar"}
          />
        </span>
      </View>
      <Text
        style={{
          marginBottom: 36,
          color: upduoMediumGray,
        }}
      >
        {formattedSummitDateRangeString(
          new Date(summit.startDate),
          new Date(summit.endDate)
        )}
      </Text>
      <Text style={headerStyle}>{"About this event"}</Text>
      <Text style={{ color: upduoPrimaryBlack }}>{summit.description}</Text>
    </View>
  );
}
